import { PersonaCategoriaModel } from "./persona-categoria.model";
import { PersonaDireccionModel } from "./persona-direccion.model";

export class PersonaModel {
  id: number = 0;
  guid: string = '';
  empresa: number = 0;
  identificador: string = '';
  nif: string = '';
  nombre: string = '';
  apellidos: string = '';
  telefono: string = '';
  email: string = '';
  observaciones: string = '';
  idCategoria: number = 0;
  idEstado: number = 0;
  direccion: PersonaDireccionModel = new PersonaDireccionModel();
  categoria: PersonaCategoriaModel = new PersonaCategoriaModel();

  constructor() { }
}
